module.exports = __webpack_public_path__ + "media/images/new/avatar-AudreyAirstream-29999d14664c56d50d782b7456c48863.png";